import { AnalyticsBrowser } from '@segment/analytics-next';
import type { JSX, ReactNode } from 'react';
import { useMemo } from 'react';

import { SegmentContext } from './SegmentContext';

interface SegmentProviderProps {
  writeKey: string;
  children: ReactNode;
}

export const SegmentProvider = (props: SegmentProviderProps): JSX.Element => {
  const segment = useMemo(() => {
    const analytics = new AnalyticsBrowser();
    // Without a write key (e.g. ephemeral/preview envs) skip load() so the SDK
    // never requests cdn.segment.com settings, which 404s on an empty write key
    // and floods the console. Calls on the unloaded instance are safely buffered.
    if (props.writeKey) {
      analytics.load({ writeKey: props.writeKey });
    }

    return analytics;
  }, [props.writeKey]);

  return (
    <SegmentContext.Provider value={segment}>
      {props.children}
    </SegmentContext.Provider>
  );
};
